<template>
  <div id="app" :class="{grey: otherConfig.grey === 1}">
<!--    <h1 v-hello="msg"></h1>-->
    <Header :etcc-link="otherConfig.etccLink" :sciiie-link="otherConfig.sciiieLink"/>
    <Navbar/>
    <keep-alive>
      <router-view @changechannelindex="changeNavbarIndex"></router-view>
    </keep-alive>
    <Footer :address-detail="otherConfig.addressDetail" :copyright-info="otherConfig.copyrightInfo"/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import {reqOtherConfig} from "@/api";

export default {
  name: 'App',
  components: {Header, Navbar, Footer},
  data() {
    return {
      otherConfig: {
        addressDetail: '',
        copyrightInfo: '',
        etccLink: '',
        sciiieLink: '',
        grey: false
      },
    }
  },
  computed: {

  },
  methods: {
    async getOtherConfig() {
      let result = await reqOtherConfig()
      this.otherConfig = result.data
    },
    changeNavbarIndex() {

    }
  },
  mounted() {
    this.getOtherConfig()

  }
}
</script>

<style lang="less">
  body {
    width: 100%;
    font-family: Avenir,Helvetica,Arial,sans-serif, "Segoe UI", "PingFang SC", "Noto Sans", "Noto Sans CJK SC", "Microsoft YaHei", "微软雅黑";
    background-color:@baseLightBgColor;
    webkit-box-sizing:border-box;
    moz-box-sizing:border-box;
    box-sizing:border-box;
    min-width: 1336px;
  }
  #app {
    &.grey {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);filter: gray;
    }
  }
  #nprogress .bar {
    background: #ED2B25 !important;
  }
  a {
    text-decoration: none !important;
  }
  a:hover {
    text-decoration: none !important;
  }
  a:visited {
    text-decoration: none !important;
  }
  a:active {
    text-decoration: none !important;
  }
</style>
